var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row empty-basket-container" }, [
    _c("div", { staticClass: "col-12" }, [
      _c("div", { staticClass: "empty-basket-wrapper" }, [
        _c("div", { staticClass: "empty-basket-box" }, [
          _vm._m(0),
          _vm._v(" "),
          _c("h5", [_vm._v(_vm._s(_vm.$resourceString["backet.EmptyBasket"]))])
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "empty-basket-icon" }, [
      _c("span", { staticClass: "png-icon png-icon-icons-glyph--k-my-basket" })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }